import messageHub from './hub'

const install = function(Vue) {
  Vue.prototype.$messageHub = messageHub
}

export default { install }
